// extracted by mini-css-extract-plugin
export default {"container":"PSUFAi","xs":"qlvTXa","content":"c8jIV2","first-image":"BChjF5","firstImage":"BChjF5","second-image":"m3ku6f","secondImage":"m3ku6f"};